import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackbarContainer = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={(event, reason) => {
        if (reason === 'timeout') {
          onClose();
        }
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      disableWindowBlurListener
    >
      <Alert severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

const SnackbarProvider = () => {
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const closeSnackbar = () => {
    setSnackbarConfig((prevConfig) => ({ ...prevConfig, open: false }));
  };

  const showSnackbar = (message, severity = 'info') => {
    setSnackbarConfig({ open: true, message, severity });
    setTimeout(() => {
      setSnackbarConfig((prevConfig) => ({ ...prevConfig, open: false }));
    }, 4000);
  };

  useEffect(() => {
    if (snackbarConfig.open) {
      const appContainer = document.createElement('div');
      document.body.appendChild(appContainer);

      const snackbarRoot = createRoot(appContainer);

      snackbarRoot.render(
        <SnackbarContainer
          open={snackbarConfig.open}
          message={snackbarConfig.message}
          severity={snackbarConfig.severity}
          onClose={closeSnackbar}
        />
      );

      return () => {
        setTimeout(() => {
          snackbarRoot.unmount();
          document.body.removeChild(appContainer);
        }, 4000);
      };
    }
  }, [snackbarConfig]);

  return {
    showSnackbar,
  };
};

export default SnackbarProvider;
